`@if (interval === 'day' && daySummaryItems.length) {
  <div class="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 mb-2 text-xs md:text-sm">
    @for (item of daySummaryItems; track item.label) {
      <div class="flex items-center gap-1.5">
        <span class="font-semibold" [style.color]="item.color">{{ item.label }}:</span>
        @for (part of item.parts; track $index) {
          <span class="whitespace-nowrap">
            @if (part.label) {
              <span class="text-gray-500 dark:text-gray-400">{{ part.label }}</span>
            }
            {{ part.value }}
          </span>
        }
      </div>
    }
  </div>
}
<div class="w-full h-[20rem] md:h-[28rem] relative">
  <canvas baseChart
          [type]="chartType()"
          [data]="chartData()"
          [options]="chartOptions()"
          [plugins]="chartPlugins"
          class="w-full h-auto md:h-full">
  </canvas>
  @if (loading) {
    <div class="absolute inset-0 flex items-center justify-center bg-white dark:bg-black pointer-events-none select-none">
      <div class="flex items-center space-x-2 text-gray-700 text-sm">
        <svg class="animate-spin h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        <span>…</span>
      </div>
    </div>
  }
</div>
